import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { SearchResultsLayoutComponent } from './search-results-layout.component';



@NgModule({
  declarations: [SearchResultsLayoutComponent],
  exports: [SearchResultsLayoutComponent],
  imports: [
    CommonModule,
    FormsModule,
    CardComponent
  ]
})
export class SearchResultsModule {
  static component = SearchResultsLayoutComponent;
}
